import React from 'react';
import PropTypes from 'prop-types';
import './Loading.css';

const Loading = ({ mini, simple }) => {
  return (
    <div className={simple ? 'loading--simple' : `loading ${mini && 'loading--mini'}`}>
      <div className="loading-text">Loading...</div>
      <div className="pulseSpinner">
        <div className="pulseSpinner-doubleBounce1" />
        <div className="pulseSpinner-doubleBounce2" />
      </div>
    </div>
  );
};

Loading.propTypes = {
  mini: PropTypes.bool,
  simple: PropTypes.bool,
};

Loading.defaultProps = {
  mini: false,
  simple: false,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/common/Loading.jsx